export const RFM_LAYOUT: Record<string, { column: string; row: string; className: string }> = {
  previouslyLoyal: { column: "1 / 3", row: "1 / 2", className: "bg-chart-primary/35" },
  atRisk: { column: "1 / 3", row: "2 / 4", className: "bg-chart-primary/25" },
  dormant: { column: "1 / 3", row: "4 / 6", className: "bg-chart-primary/15" },
  loyal: { column: "3 / 5", row: "1 / 3", className: "bg-chart-primary/90" },
  needsAttention: { column: "3 / 4", row: "3 / 4", className: "bg-chart-primary/60" },
  almostLost: { column: "3 / 4", row: "4 / 6", className: "bg-chart-primary/45" },
  champions: { column: "5 / 6", row: "1 / 3", className: "bg-chart-primary" },
  active: { column: "4 / 6", row: "3 / 5", className: "bg-chart-primary/85" },
  promising: { column: "4 / 5", row: "5 / 6", className: "bg-chart-primary/70" },
  new: { column: "5 / 6", row: "5 / 6", className: "bg-chart-primary/75" },
}
